import { Container, Grid } from "@material-ui/core"
import HomePage from "../../Home"
import { useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect } from "react"
import { obtenerliquidacionesAuthGrupoAction } from "../../../ducks/liquidacionesAuthDuck"
import TGrupoLiquidacionesAuth from "../TGrupoLiquidacionesAuth"
const VGrupoLiquidacionesAuth = () => {
    const { idGrupo } = useParams()
    console.log("🚀 ~ file: index.jsx:10 ~ VGrupoLiquidacionesAuth ~ idGrupo:", idGrupo)
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerliquidacionesAuthGrupoAction({ IdPagoGrupal: idGrupo }))
    }, [dispatch, idGrupo])
    return (
        <HomePage>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <h3>Liquidaciones Autorizados</h3>
                    </Grid>
                    <Grid item xs={12}>
                        <TGrupoLiquidacionesAuth />
                    </Grid>
                </Grid>
            </Container>
        </HomePage>
    )
}
export default VGrupoLiquidacionesAuth